export default "__VITE_ASSET__BO2H4Xik__"